module.exports = __webpack_public_path__ + "static/cash-e2277210cc970922974412f795c81bec.svg";